<script>

    import { onMount, createEventDispatcher } from 'svelte';
    import {DateTime, easepick} from '@easepick/bundle';
    import { RangePlugin } from '@easepick/range-plugin';
    import { LockPlugin } from '@easepick/lock-plugin';
    import dayjs from "dayjs";

    const dispatch = createEventDispatcher();

    let ep = null;
    let initialized = false;

    export let element = null;
    export let autoApply = false;
    export let firstDay = 1;
    export let format = 'YYYY-MM-DD';
    export let calendars = 1;
    export let css = [];
    export let lang = 'de-DE';
    export let startDate = null;
    export let endDate = null;
    let maxDate = dayjs().format('YYYY-MM-DD')

    export const open = () => {

        if (!initialized) initialize();

        ep.show();

    }

    let onSelected = (e) => {

        ep.hide();

        dispatch('selected', {
            startDate: e.detail['start'],
            endDate: e.detail['end']
        });

    };

    let initialize = () => {

        initialized = true;

        let date = new Date()

        ep = new easepick.create({
            element: element,
            calendars: calendars,
            firstDay: firstDay,
            autoApply: autoApply,
            css: css,
            locale: {
                cancel: 'Abbrechen',
                apply: 'Anwenden'
            },
            lang: 'de-CH',
            // inline: true,
            plugins: [RangePlugin, LockPlugin],
            RangePlugin: {
                tooltipNumber(num) {
                    return num - 1;
                },
                locale: {
                    one: 'day',
                    other: 'days',
                },
                startDate: startDate,
                endDate: endDate
            },
            LockPlugin: {
                maxDate: maxDate,
                inseparable: true
            },
            setup: (picker) => {
                picker.on('select', onSelected);
            }
        })
    }

</script>